//Import React Hooks
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';

import dayjs from 'dayjs';

// import created components  :
import Background from '../../components/background/Background.jsx'
import ProgressBar from '../../components/progressbar/ProgressBar.jsx'
import WallyBanner from '../../components/wallybanner/WallyBanner.jsx' //<WallyBanner />

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { clientSlice } from "../../store/clientSlice.js";
import { elevesSlice } from "../../store/elevesSlice.js";
import { selectedCreneauxSlice } from "../../store/selectedCreneauxSlice.js";
import { getSelectedCreneaux } from "../../store/selectors.js";

// API fetch
import axios from "axios";
import { baseURL } from '../../config/api-config.js';

//MUI :
import Button from '@mui/material/Button';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import Alert from '@mui/material/Alert';
import TextField from '@mui/material/TextField';

import { MuiTelInput, matchIsValidTel } from 'mui-tel-input'

//Translate utils :
import { translator } from "../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)


function StartResa() { // full page as component imported in router

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [phone, setPhone] = useState([])
    const [phoneError, setPhoneError] = useState(false)
    const [telFound, setTelFound] = useState(false)
    const [showAlert, setShowAlert] = useState(false)
    const [showFail, setShowFail] = useState(false)
    const [tempClient, setTempClient] = useState()
    const [tryCpt, setTryCpt] = useState(0)
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState(true);
    const lang = useSelector(getLang) //global state : language




    const handleChangePhone = (newValue, info) => {
        matchIsValidTel(newValue) ? setPhoneError(false) : setPhoneError(true);
        setPhone([newValue, info]);
    }

    const handleEmailChange = e => {

        let cleanEmail = emailCleaner(e.target.value);

        setEmail(cleanEmail);
        //console.log(e.key);

        if (e.target.validity.valid) {
            setEmailError(false);
        } else {
            setEmailError(true);
        }
    };

    function emailCleaner(raw) {
        let clean = raw.toLowerCase();
        clean = clean.split(" ").join("");
        return clean
    }

    function startNewClient() {

        setBackup(); // trigger backup procedure

        let staticClient = { id_client: -1, prenom: "", nom: "", email: "", tel: "", tel2: "", adresse_vacances: "", is_eleve: false, eleve_id: 0 };
        // set client in global state
        dispatch(elevesSlice.actions.initEleves([])); // reset list to empty
        //dispatch(selectedCreneauxSlice.actions.initCreneaux([]));// reset list to empty
        dispatch(clientSlice.actions.setClient(staticClient));
        navigate("../eleves");
    }

    async function findClient() {

        console.log(phone[1].numberValue);
        let result = await getOneClient();

        if (result.length > 0) { //client found
            setTelFound(true);
            setTempClient(result[0]);
            setShowAlert(false);
        }
        else { //not found
            setTelFound(false);
            setTempClient({});
            setShowAlert(true);
        }


    }

    function confirmEmail() {

        if (email === tempClient.email) { //confirmation ok
            setTelFound(false);
            setShowFail(false);
            dispatch(elevesSlice.actions.initEleves([])); // reset list to empty
            //dispatch(selectedCreneauxSlice.actions.initCreneaux([]));// reset list to empty
            dispatch(clientSlice.actions.setClient(tempClient));
            navigate("../eleves");
        }
        else {
            setShowFail(true);
            setTryCpt(tryCpt + 1)
            if (tryCpt >= 5) {
                setTryCpt(0);
                setTelFound(false);
                setShowFail(false);
            }

        }


    }

    async function getOneClient() { // get list of formules from DB

        try {
            const response = await axios({
                method: 'GET',
                url: baseURL + `/client/phone/${phone[1].numberValue}`,
            });
            //console.log(response.data.data);
            if (response.status === 200) {
                const client = response.data.data;
                return client;
            }
            else {
                return [];
            }
        } catch (err) {
            console.error(err);
            return [];
        }
    }

    function setBackup() {

        //// --- Check backup
        axios.get(baseURL + "/backup/1").then((response) => {
            console.log(response);
            if (response.status === 204) { // at first backup, table is empty -> we set first backup date

                axios.post(baseURL + "/backup",
                    {
                        date_backup: "2024-01-01" //dayjs().format("YYYY-MM-DD")
                    }
                ).then((response) => {
                    if (response.status === 201) {
                        console.log(response.data);
                    }
                })

            }
            else {
                let dateBackup = response.data.data.date_backup;
                let today = dayjs();
                let backupNeeded = today.isAfter(dateBackup, "day");
                console.log("backup à faire :", backupNeeded);

                if (backupNeeded === true) {
                    // on déclenche l'envoie du mail avec la base sqlite
                    axios.post(baseURL + "/mailing/mail-backup").then((response) => {

                        //on modifie la date du dernier backup
                        if (response.status === 200) {

                            axios.put(baseURL + "/backup/1",
                                {
                                    date_backup: dayjs().format("YYYY-MM-DD")
                                }
                            ).then((response) => {
                                console.log(response.data)

                            })
                        }

                    })

                }
            }

        });
    }

    return (
        <div className="bg-relative">
            <Background ind={1} />
            <main> {/* main is positionned absolute */}

                <div className="main-relative">
                    <WallyBanner />
                    <div className="main-progress-bar">
                        <ProgressBar currentStep={1} total={5} />
                    </div>

                    <div className="start-resa">

                        <div className="start-resa-intro">
                            <h3>{translator("Bienvenue sur la plateforme de réservation", lang, "startResaTitle")}</h3>
                        </div>

                        <div className="start-resa-main">

                            <div className="start-resa-main-question">
                                <p >{translator("Question : \n avez vous déjà réservé vos cours sur cette plateforme?", lang, "startResaQuestion")}</p>
                            </div>

                            <div className="start-resa-choix">

                                <div className="start-resa-choix-oui">
                                    {telFound === true ?
                                        <>
                                            <p>{`Bonjour ${tempClient.prenom}, \n ${translator("pour valider veuillez confirmer votre adresse email :", lang, "startResaMailConfirm")}`}</p>

                                            <TextField
                                                className="start-resa-choix-confirm-email"
                                                required
                                                label="Email"
                                                value={email}
                                                onChange={handleEmailChange}
                                                error={emailError}
                                                disabled={tryCpt >= 5}
                                                helperText={emailError ? translator("Veuillez saisir une adresse mail valide", lang, "startResaMailValid") : ""}
                                                inputProps={{
                                                    type: "email",
                                                }}
                                            />

                                            <Button
                                                className="start-resa-choix-confirm-bouton"
                                                variant="contained"
                                                disabled={emailError}
                                                onClick={_ => confirmEmail()}>
                                                {tryCpt >= 5 ? translator("Réessayer", lang, "startResaBtRetry") : translator("Confirmer", lang, "startResaBtConfirm")}
                                            </Button>

                                            {showFail === true &&
                                                <Alert severity="error">
                                                    {tryCpt >= 5 ? translator("Vous avez atteint le nombre limite d'essais, vous pouvez essayer à nouveau", lang, "startResaMailError1") :
                                                        translator(
                                                            "Ce mail n'est pas associé à votre numéro de téléphone", lang, "startResaMailError2")
                                                    }
                                                </Alert>
                                            }
                                        </>
                                        :
                                        <>
                                            <p>{translator("Si oui, aidez nous à vous retrouver en renseignant votre numéro de téléphone :", lang, "startResaClient1")}</p>

                                            <MuiTelInput
                                                className="start-resa-choix-oui-tel"
                                                error={phoneError}
                                                forceCallingCode
                                                focusOnSelectCountry
                                                defaultCountry="FR"
                                                preferredCountries={['FR', 'BE', 'DE', 'NL', 'ES', 'IT', 'GB', 'US']}
                                                value={phone[0]}
                                                onChange={handleChangePhone} />

                                            <Button
                                                className="start-resa-choix-oui-bouton"
                                                variant="contained"
                                                disabled={phoneError || phone[0] === undefined}
                                                onClick={_ => findClient()}>
                                                {translator("Retrouvez moi", lang, "startResaClientBt")}
                                            </Button>

                                            {showAlert === true &&
                                                <Alert severity="error">{translator("Ce numéro ne permet pas de vous retrouver", lang, "startResaClientNoMatch")}</Alert>
                                            }
                                        </>
                                    }

                                </div>

                                <div className="start-resa-choix-non">
                                    <p>{translator("Nouveau client?\n Bienvenue chez nous!", lang, "startResaClientNew")}</p>
                                    <Button
                                        className="start-resa-choix-non-bouton"
                                        variant="contained"
                                        onClick={_ => startNewClient()}>
                                        {translator("Reservez vos sessions", lang, "homeBt1")}
                                    </Button>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>
            </main>
        </div >
    );
}

export default StartResa;